import React from 'react';
import clsx from 'clsx';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type SwitcherIconProps = {
    className: any;
};

const renderSwitcherIcon = (
    className = '',
    switcherIcon: React.ReactElement<SwitcherIconProps>,
    showLine: boolean | undefined,
    {
        isLeaf,
        expanded,
        loading,
    }: { isLeaf?: boolean; expanded?: boolean; loading?: boolean }
): any => {
    if (loading) {
        return (
            <HourglassEmptyOutlinedIcon className="rc-tree-switcher-loading-icon" />
        );
    }
    if (isLeaf) {
        return showLine ? (
            <InsertDriveFileOutlinedIcon
                className={clsx('rc-tree-switcher-noop', className)}
            />
        ) : null;
    }
    const switcherCls = `rc-tree-switcher-icon`;
    if (React.isValidElement(switcherIcon)) {
        return React.cloneElement(switcherIcon, {
            className: clsx(switcherIcon.props.className || '', switcherCls),
        });
    }

    if (switcherIcon) {
        return switcherIcon;
    }

    if (showLine) {
        return expanded ? (
            <IndeterminateCheckBoxOutlinedIcon
                className={clsx('rc-tree-switcher-line-icon', className)}
            />
        ) : (
            <AddBoxOutlinedIcon
                className={clsx('rc-tree-switcher-line-icon', className)}
            />
        );
    }
    return <ExpandMoreIcon className={switcherCls} />;
};

export default renderSwitcherIcon;
